import { DialogContent, styled } from "@mui/material";
import { JoyrideActivator } from "components/joyride/JoyrideActivator";
import { LayerSet } from "types/types";
import { LayerSetDialogMap } from "./LayerSetDialogMap";
import { LayerSetDialogSidePanel } from "./LayerSetDialogSidePanel";

interface Props {
  layerSet: LayerSet;
}

export function LayerSetDialogContent(props: Props) {
  const { layerSet } = props;
  return (
    <StyledDialogContent>
      <JoyrideActivator />
      <LayerSetDialogSidePanel layerSet={layerSet} className="side-panel" />
      <LayerSetDialogMap layerSet={layerSet} />
    </StyledDialogContent>
  );
}

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0;
  .leaflet-container {
    flex: 1 1 100%;
  }
  .side-panel {
    flex: 0 0 400px;
    max-width: 400px;
  }
`;
